import { Component, Input } from '@angular/core';
import { InsightsDashboardStats } from '../../models/insights-dashboard.model';

@Component({
    selector: 'app-ask-ayen-statistics-cards',
    templateUrl: './statistics-cards.component.html',
    styleUrl: './statistics-cards.component.scss',
    standalone: false
})
export class StatisticsCardsComponent {
  private _stats: InsightsDashboardStats | null = null;

  @Input()
  set stats(value: InsightsDashboardStats | null) {
    this._stats = value;
    this.cards = this.buildCards(value);
  }

  cards = this.buildCards(null);

  private buildCards(stats: InsightsDashboardStats | null) {
    return [
      { value: stats?.total_questions_count ?? 0, label: 'إجمالي الأسئلة', color: '#181818' },
      {
        value: `${stats?.answered_questions_count ?? 0} (${stats?.answered_questions_percentage ?? 0}%)`,
        label: 'المجاب عنها',
        color: '#379B79',
      },
      { value: stats?.under_review_questions_count ?? 0, label: 'الأسئلة المعلقة', color: '#FE5956' },
      {
        value: this.formatDuration(stats?.avg_first_response_seconds),
        label: 'متوسط وقت الرد',
        color: '#0774A9',
      },
    ];
  }

  private formatDuration(totalSeconds?: number): string {
    if (!totalSeconds || totalSeconds <= 0) return '-';

    const days = Math.floor(totalSeconds / 86400);
    if (days > 0) return `${days} ${days === 1 ? 'يوم' : 'أيام'}`;

    const hours = Math.floor(totalSeconds / 3600);
    if (hours > 0) return `${hours} ${hours === 1 ? 'ساعة' : 'ساعات'}`;

    const minutes = Math.floor(totalSeconds / 60);
    if (minutes > 0) return `${minutes} ${minutes === 1 ? 'دقيقة' : 'دقائق'}`;

    return `${totalSeconds} ثانية`;
  }
}
